import { render } from "./NavBar_mobile.vue?vue&type=template&id=2bdd15d9"
import script from "./NavBar_mobile.vue?vue&type=script&lang=js"
export * from "./NavBar_mobile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__